import React from "react";

const NotAuthorized = () => {
  return (
    <div className="page page-center">
      <div className="container-tight py-4">
        <div className="empty">
          <div className="empty-header">403</div>
          <p className="empty-title">Forbidden</p>
          <p className="empty-subtitle text-secondary">
          You do not have permission to access this page.
          </p>
          <div className="mt-4">
            <a href="/" className="btn btn-primary">
              Go Back to Dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotAuthorized;
